import { Component, inject, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';

type SyncStatus = 'idle' | 'loading' | 'success' | 'error';

@Component({
  selector: 'app-bc-sync',
  standalone: true,
  imports: [MatButtonModule, MatProgressSpinnerModule, MatIconModule],
  templateUrl: './bc-sync.component.html',
  styleUrl: './bc-sync.component.css',
})
export class BcSyncComponent {
  private readonly _httpClient = inject(HttpClient);

  bcSyncStatus = signal<SyncStatus>('idle');
  bcSyncMessage = signal<string>('');

  devopsSyncStatus = signal<SyncStatus>('idle');
  devopsSyncMessage = signal<string>('');

  syncBcToDb() {
    this.bcSyncStatus.set('loading');
    this.bcSyncMessage.set('');
    this._httpClient.post('/api/sync/bc-to-db', {}).subscribe({
      next: () => {
        this.bcSyncStatus.set('success');
        this.bcSyncMessage.set('BC data synced to database successfully.');
      },
      error: (err) => {
        this.bcSyncStatus.set('error');
        this.bcSyncMessage.set(err?.error?.message ?? err?.message ?? 'Sync failed. Please try again.');
      },
    });
  }

  syncDbToDevOps() {
    this.devopsSyncStatus.set('loading');
    this.devopsSyncMessage.set('');
    this._httpClient.post('/api/sync/db-to-devops', {}).subscribe({
      next: () => {
        this.devopsSyncStatus.set('success');
        this.devopsSyncMessage.set('Database synced to Azure DevOps successfully.');
      },
      error: (err) => {
        this.devopsSyncStatus.set('error');
        this.devopsSyncMessage.set(err?.error?.message ?? err?.message ?? 'Sync failed. Please try again.');
      },
    });
  }
}
